import Helper from '@ember/component/helper';
import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import { isTesting, macroCondition } from '@embroider/macros';
export default class QuerySelector extends Helper {
  @tracked selector;
  @tracked elements;

  waitForElements = task({ restartable: true }, async () => {
    let count = 0;
    if (macroCondition(isTesting())) {
      return;
    }

    while (!this.element) {
      this.findElements();

      await timeout(25);
      count = count + 1;

      if (count > 100) {
        break;
      }
    }
  });

  findElements() {
    if (this.within) {
      this.elements = this.within.querySelectorAll(this.selector);
    } else {
      this.elements = document.querySelectorAll(this.selector);
    }
  }

  compute([selector], { id, within }) {
    this.selector = selector;
    this.within = within;

    this.findElements();

    if (!this.elements) {
      next(() => {
        this.waitForElements.perform();
      });
    }

    return this.elements;
  }
}
